<template>
  <div id="app">
    <PageHeader fixed />
    <main>
      <section id="home" style="position: relative; overflow: hidden" class="teal">
        <PictureImg
          src="/images/landing/landing-bg"
          alt="Landing Background"
          :extensions="['webp', 'png', 'svg']"
          :lazy="false"
          img-class="landing-bg"
        />
        <PictureImg
          src="/images/landing/eagle"
          alt="Eagle"
          :extensions="['svg', 'webp', 'png']"
          :lazy="false"
          img-class="absolute-center eagle"
        />
        <PictureImg
          src="/images/landing/butterfly-1"
          alt="Butterfly 1"
          :extensions="['svg', 'webp', 'png']"
          :lazy="false"
          img-class="absolute-center butterfly-1"
        />
        <PictureImg
          src="/images/landing/butterfly-2"
          alt="Butterfly 2"
          :extensions="['svg', 'webp', 'png']"
          :lazy="false"
          img-class="absolute-center butterfly-2"
        />
        <PictureImg
          src="/images/landing/rasylva-logo-white"
          alt="Rasylva.id"
          :extensions="['svg', 'webp', 'png']"
          :lazy="false"
          img-class="rasylva-logo-white"
        />
        <PictureImg
          v-for="(firefly, key) in fireflies"
          :key="key"
          src="/images/landing/firefly"
          alt="Firefly"
          :extensions="['svg', 'webp', 'png']"
          :lazy="false"
          img-class="absolute-center firefly"
          :img-style="{ top: firefly.top, left: firefly.left, transform: firefly.transform }"
        />
        <h2 class="landing-quote center font-medium text-balance" style="color: #dedede">
          A software development startup that combines technology with natural science to deliver digital solutions
        </h2>
      </section>

      <section id="why" class="relative">
        <div class="sky-bg">
          <div class="sky-text flex flex-col gap-4 lg:gap-8 max-w-xl lg:max-w-8xl ph-3">
            <div class="flex flex-col lg:gap-8 justify-center items-center">
              <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 uppercase">
                Empowering Science Through Technology
              </h2>
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center lg:pr-6">
                <PictureImg
                  src="/images/landing/technology"
                  alt=""
                  :extensions="['webp', 'png']"
                  :lazy="false"
                  img-class="w-4/5 lg:w-[48vh] lg:pr-6 object-contain"
                />
                <div>
                  <p class="text-lg lg:text-2xl lg:text-left">
                    Kami percaya bahwa teknologi dan sains dapat berjalan beriringan untuk menciptakan solusi yang
                    berdampak.
                  </p>
                  <p class="text-lg lg:text-2xl lg:text-left">
                    Melalui pengembangan aplikasi dan website, Rasylva.id mendukung berbagai organisasi dalam mewujudkan
                    transformasi digital yang relevan dan berkelanjutan.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <PictureImg
            src="/images/landing/hills"
            alt="Hills"
            :lazy="false"
            :extensions="['svg', 'webp', 'png']"
            :img-style="{ bottom: '-2px', position: 'absolute' }"
          />
        </div>
      </section>

      <section id="advantages" class="h-auto lg:h-svh" style="position: relative; background: #83bb60">
        <div class="header-space"></div>
        <div class="advantage">
          <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 lg:mb-12 uppercase">
            Our Value
          </h2>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 center-align">
            <div class="flex-item advantage__item">
              <PictureImg
                src="/images/landing/illus-quality"
                alt="Quality Illustration"
                :extensions="['svg', 'webp', 'png']"
                img-class="lg:mb-2"
                :img-style="{ display: 'block', height: '18vh', maxHeight: '150px', margin: 'auto' }"
              />
              <h4 class="text-xl lg:text-2xl m-0 lg:mb-2 txt--bold">Quality Software</h4>
              <span class="text-lg lg:text-xl"
                >Kami membuat aplikasi dengan memikirkan kemudahan penggunaan dan kinerja yang baik.</span
              >
            </div>
            <div class="flex-item advantage__item">
              <PictureImg
                src="/images/landing/illus-affordable"
                alt="Affordable Illustration"
                :extensions="['svg', 'webp', 'png']"
                img-class="lg:mb-2"
                :img-style="{ display: 'block', height: '18vh', maxHeight: '150px', margin: 'auto' }"
              />
              <h4 class="text-xl lg:text-2xl m-0 lg:mb-2 txt--bold">Affordable Pricing</h4>
              <span class="text-lg lg:text-xl">
                Kami menyesuaikan harga paket aplikasi agar mahasiswa hingga profesional dapat menggunakan aplikasi kami
                sesuai kebutuhan.
              </span>
            </div>
            <div class="flex-item advantage__item">
              <PictureImg
                src="/images/landing/illus-friendly"
                alt="Friendly Illustration"
                :extensions="['svg', 'webp', 'png']"
                img-class="lg:mb-2"
                :img-style="{ display: 'block', height: '18vh', maxHeight: '150px', margin: 'auto' }"
              />
              <h4 class="text-xl lg:text-2xl m-0 lg:mb-2 txt--bold">Customer Friendly</h4>
              <span class="text-lg lg:text-xl"
                >Kami selalu siap untuk membantu saat anda membutuhkan bantuan dalam penggunaan aplikasi kami.</span
              >
            </div>
          </div>
        </div>
      </section>

      <section id="products" class="h-auto lg:h-svh bottom-space" style="position: relative">
        <div class="header-space"></div>
        <PictureImg
          src="/images/landing/liana-left"
          alt="Liana Left"
          :extensions="['svg', 'webp', 'png']"
          img-class="liana-left"
        />
        <PictureImg
          src="/images/landing/liana-right"
          alt="Liana Right"
          :extensions="['svg', 'webp', 'png']"
          img-class="liana-right"
        />
        <div class="flex flex-col items-center justify-start lg:justify-center h-full">
          <h2
            class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 mt-24 mb-12 lg:mt-12 lg:mb-12 uppercase"
          >
            Products
          </h2>
          <div class="lg:max-w-7xl px-9 row grid grid-cols-1 lg:grid-cols-3 gap-10 items-stretch my-0 mx-auto">
            <div class="s12 m4">
              <div class="card" style="height: 100%">
                <div class="card-image">
                  <PictureImg
                    src="/inventum/icons/android-icon-512x512"
                    alt="Inventum Logo"
                    :extensions="['webp', 'png']"
                    :img-style="{ maxWidth: '250px', margin: 'auto', height: '150px', width: 'auto' }"
                  />
                </div>
                <div class="card-content" style="height: 320px">
                  <span class="font-bold text-2xl lg:text-3xl">Inventum</span>
                  <p class="text-lg lg:text-xl mt-4">
                    Inventum adalah Alat Inventarisasi Tumbuhan yang dapat membantu kamu untuk menginput data tumbuhan
                    secara offline, dengan output berupa spreadsheet yang dapat kamu unduh (xlsx/csv).
                  </p>
                </div>
                <div class="card-action" style="position: absolute; bottom: 0; width: 100%">
                  <a class="btn teal white-text" href="/products/inventum">Pelajari Lebih Lanjut</a>
                </div>
              </div>
            </div>
            <div class="s12 m4">
              <div class="card" style="height: 100%">
                <div class="card-image">
                  <PictureImg
                    src="/beecounter/icon/png/logo-color"
                    alt="BeeCounter Logo"
                    :extensions="['png']"
                    :img-style="{ maxWidth: '250px', margin: 'auto', height: '150px', width: 'auto' }"
                  />
                </div>
                <div class="card-content" style="height: 320px">
                  <span class="font-bold text-2xl lg:text-3xl">BeeCounter</span>
                  <p class="text-lg lg:text-xl mt-4">
                    BeeCounter adalah Alat Penghitung Lebah yang dapat membantu kamu untuk menginput data lebah, dengan
                    output berupa tabel yang dapat kamu copy ke spreadsheet.
                  </p>
                </div>
                <div class="card-action" style="position: absolute; bottom: 0; width: 100%">
                  <a class="btn teal white-text" href="/beecounter">Buka Aplikasi</a>
                </div>
              </div>
            </div>
            <div class="s12 m4 hide-on-small-only">
              <div class="card" style="height: 100%">
                <div class="card-image">
                  <div
                    style="max-width: 250px; height: 250px; margin: auto; height: 150px; width: auto; background: white"
                  ></div>
                </div>
                <div class="card-content" style="height: 320px">
                  <span class="font-bold text-2xl lg:text-3xl">Coming soon...</span>
                  <p class="text-sm lg:text-xl mt-4">Tunggu aplikasi kami selanjutnya! :D</p>
                </div>
                <div class="card-action" style="position: absolute; bottom: 0; width: 100%">
                  <span class="btn teal white-text" :disabled="true">Coming soon...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="services"
        class="teal white-text sevices-section pt-18 pb-12 lg:pt-24 lg:pb-18 h-auto lg:h-svh"
        :style="{ backgroundImage: `url('/images/services/web-app/geometric-1.webp') !important` }"
      >
        <h2 class="center-align text-3xl lg:text-4xl font-bold white-text lg:mt-12 lg:mb-12 uppercase">Service</h2>
        <div class="container-lg items-center grid grid-cols-1 lg:grid-cols-2 gap-4 pb-8">
          <div class="hide-on-med-and-down">
            <PictureImg
              src="/images/services/web-app/web-app-development"
              alt="Web App Development"
              version="1"
              :extensions="['webp', 'png']"
              :lazy="false"
              img-class="services-image"
            />
          </div>
          <div>
            <div class="services-text">
              <h1 class="font-bold text-4xl lg:text-5xl hide-on-med-and-down">Web/App Development Service</h1>
              <div class="hide-on-large-only text-center">
                <PictureImg
                  src="/images/services/web-app/web-app-development"
                  alt="Web App Development"
                  version="1"
                  :extensions="['webp', 'png']"
                  :lazy="false"
                  img-class="services-image"
                />
              </div>
              <h1 class="hide-on-large-only font-bold text-3xl lg:text-5xl">Web/App Development Service</h1>
              <p class="text-xl lg:text-3xl text-balance font-medium">
                Kami menghadirkan jasa pengembangan software yang berkualitas, <i>customizable</i>, dan
                <i>maintainable</i> sebagai solusi digital yang berkelanjutan.
              </p>
              <a href="/services/web-app" class="btn waves-effect green btn-large font-medium uppercase">
                Pelajari Lebih Lanjut
              </a>
            </div>
          </div>
        </div>
      </section>

      <section
        id="partners"
        style="position: relative; height: auto; min-height: 100vh"
        class="flex items-center justify-center flex-col"
      >
        <h2
          class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 mt-24 mb-12 lg:mt-12 lg:mb-12 uppercase"
        >
          Partners
        </h2>
        <div class="container-lg row grid grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/genau"
              alt="Genau Indonesia"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/hutanin"
              alt="Hutan.in"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/belantara-mandara"
              alt="Belantara Mandara"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/rh-itera"
              alt="RH Itera"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/stp-ipb"
              alt="STP IPB"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/kanopi"
              alt="Kanopi Indonesia"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/fahutan-ipb"
              alt="Fakultas Kehutanan IPB"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
          <div class="rounded-lg card p-2 lg:p-4 m-0">
            <PictureImg
              src="/images/landing/partners/bio-ugm"
              alt="Fakultas Biologi UGM"
              :extensions="['webp', 'png']"
              img-class="partner-image"
              :img-style="{ width: '100%', objectFit: 'contain' }"
            />
          </div>
        </div>
        <PictureImg
          src="/images/landing/birds"
          alt="Birds"
          :extensions="['svg', 'webp', 'png']"
          :img-style="{ display: 'block', width: '38vh', margin: 'auto', paddingTop: '4vh' }"
        />
      </section>

      <section
        id="cta"
        class="relative container-lg h-auto lg:h-svh mx-0 w-full lg:mx-auto mt-24 lg:mt-48 flex flex-col items-center justify-start lg:justify-center"
      >
        <div
          class="green px-2 lg:px-18 pt-24 pb-18 lg:py-24 mb-24 lg:mb-0 rounded-3xl"
          :style="{
            backgroundImage: `url('/images/services/web-app/geometric-0.webp') !important`,
            backgroundSize: 'cover !important',
            backgroundPosition: 'left center !important',
            backgroundRepeat: 'no-repeat !important',
          }"
        >
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 px-2 lg:px-6 items-center">
            <div class="text-center lg:text-left">
              <h2 class="text-5xl lg:text-8xl font-bold white-text uppercase m-0">Explore Our Solutions</h2>
              <div class="hide-on-large-only" style="text-align: center; margin-top: 24px">
                <PictureImg
                  src="/images/landing/illus-cta"
                  alt=""
                  :extensions="['webp', 'png']"
                  :img-style="{
                    display: 'block',
                    height: '28vh',
                    maxHeight: '250px',
                    margin: 'auto',
                  }"
                />
              </div>
              <p class="white-text text-2xl lg:text-3xl mv-5 font-medium text-balance">
                Dari aplikasi siap pakai hingga software yang dirancang khusus, kami siap mendukung transformasi digital
                Anda.
              </p>
              <a
                href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
                target="_blank"
                rel="noopener noreferrer"
                class="btn teal waves-effect btn-large font-medium"
                tabindex="0"
              >
                Start Your Digital Journey!
              </a>
            </div>
            <div class="hide-on-med-and-down" style="text-align: right">
              <PictureImg
                src="/images/landing/illus-cta"
                alt=""
                :extensions="['webp', 'png']"
                :img-style="{ display: 'inline-block', height: '50vh', maxHeight: '420px' }"
              />
            </div>
          </div>
        </div>
        <div
          class="forest-trees absolute bottom-0 overflow-hidden"
          style="width: 100vw; min-height: 15vh; height: 14vh"
        >
          <PictureImg
            v-for="(tree, index) in trees"
            :key="index"
            src="/images/landing/single-tree-green"
            alt="Single Tree"
            :extensions="['webp', 'svg', 'png']"
            :img-style="tree"
          />
        </div>
      </section>

      <section
        id="contact"
        class="green"
        style="position: relative; height: auto; padding-top: 40px; min-height: 26rem"
      >
        <PageFooter class="landing-footer" />
      </section>

      <ul class="scroll-nav hide-on-med-and-down">
        <li :class="{ active: activeSection === 'home' }">
          <a href="#home" aria-label="Go to home section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'why' }">
          <a href="#why" aria-label="Go to why section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'advantages' }">
          <a href="#advantages" aria-label="Go to advantages section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'products' }">
          <a href="#products" aria-label="Go to products section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'services' }">
          <a href="#services" aria-label="Go to services section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'partners' }">
          <a href="#partners" aria-label="Go to partners section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'cta' }">
          <a href="#cta" aria-label="Go to cta section" tabindex="0"><div></div></a>
        </li>
        <li :class="{ active: activeSection === 'contact' }">
          <a href="#contact" aria-label="Go to contact section" tabindex="0"><div></div></a>
        </li>
        <span class="scroll-nav__indicator" :style="indicatorStyle"></span>
      </ul>
    </main>
  </div>
</template>

<script>
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';
import PictureImg from '~/components/picture-img';

function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

export default {
  components: {
    PageFooter,
    PageHeader,
    PictureImg,
  },
  data: () => ({
    trees: [],
    fireflies: [
      { top: '22%', left: '11%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '21%', left: '17%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '26%', left: '17%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '43%', left: '82%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '46%', left: '71%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '57%', left: '78%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '71%', left: '18%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '66%', left: '25%', transform: 'translate3d(-50%, -50%, 0)' },
      { top: '74%', left: '29%', transform: 'translate3d(-50%, -50%, 0)' },
    ],
    activeSection: 'home',
    sections: ['home', 'why', 'advantages', 'products', 'services', 'partners', 'cta', 'contact'],
    sectionObserver: null,
  }),
  computed: {
    indicatorStyle() {
      const index = this.sections.indexOf(this.activeSection);
      const offset = index * 36 + 12;
      return {
        transform: `translate(-50%, ${offset}px)`,
      };
    },
  },
  async mounted() {
    this.setCssCustomProperties();
    this.wiggleFireflies();
    this.initSectionObserver();
    this.initTrees();
    // this.initListeners();
    await this.$nextTick();
    setTimeout(async () => {
      await this.$rasylvaApi.init();
    }, 10);
  },
  beforeDestroy() {
    this.destroyListeners();
    this.destroySectionObserver();
  },
  methods: {
    setCssCustomProperties() {
      window.document.body.style.overflow = 'hidden';
      this.setVhToWindowHeight();
      window.addEventListener('resize', debounce(this.setVhToWindowHeight, 500));
    },
    setVhToWindowHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    initTrees() {
      let treeCount = 24;
      if (typeof window !== 'undefined') {
        treeCount = Math.round(12 + (window.innerWidth / 1920) * 24);
        treeCount = Math.max(12, Math.min(36, treeCount));
      }
      this.trees = Array.from({ length: treeCount }, (_, i) => ({
        height: Math.random() * 5 + 8 + 'vh',
        bottom: '0',
        position: 'absolute',
        left: (i * 100) / treeCount + Math.random() * 2 - 1 + '%',
        zIndex: Math.floor(Math.random() * 4) + 1,
        opacity: (Math.random() * 0.2 + 0.85).toFixed(2),
        transform: Math.random() > 0.55 ? 'scaleX(-1)' : undefined,
      }));
    },
    randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    wiggleFireflies() {
      this.fireflies.forEach((firefly) => {
        const moveFirefly = () => {
          const randomInterval = Math.round(Math.random() * (3000 - 500)) + 500;
          firefly.transform = `translate3d(${this.randomInt(-100, 100)}%, ${this.randomInt(-100, 100)}%, 0)`;
          setTimeout(moveFirefly, randomInterval);
        };
        moveFirefly();
      });
    },
    initSectionObserver() {
      const mainEl = document.body.querySelector('main');
      const options = {
        root: mainEl,
        rootMargin: '-45% 0px -45% 0px',
        threshold: 0,
      };
      this.sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
          }
        });
      }, options);
      this.sections.forEach((sectionId) => {
        const section = mainEl.querySelector(`#${sectionId}`);
        if (section) {
          this.sectionObserver.observe(section);
        }
      });
    },
    destroySectionObserver() {
      if (this.sectionObserver) {
        this.sectionObserver.disconnect();
        this.sectionObserver = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/mixins';
@import '~/styles/variables';

main {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  padding-bottom: 0;
  height: 100vh;
  height: calc((var(--vh, 1vh) * 100));
  overflow-y: scroll;
  @media only screen and (min-width: 960px) {
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }
  section {
    @media only screen and (min-width: 960px) {
      scroll-snap-align: start;
      scroll-snap-stop: always;
    }
    height: 100vh;
    height: calc((var(--vh, 1vh) * 100));
    min-height: 36rem;
  }
}

.container {
  @media only screen and (min-width: 960px) {
    max-width: 960px;
    margin: auto;
    width: 100%;
  }
}

.scroll-nav {
  position: fixed;
  z-index: 9;
  right: 3vh;
  top: 50%;
  transform: translateY(-50%);
  list-style: none;
  border: 0;
  font-size: 100%;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(8px);
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  &__indicator {
    position: absolute;
    left: 50%;
    top: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 2px 8px rgba(51, 145, 133, 0.5);
    pointer-events: none;
    z-index: 2;
  }
  li {
    border: 0;
    font-size: 100%;
    display: list-item;
    cursor: pointer;
    position: relative;
    z-index: 1;
    a {
      padding: 12px 12px;
      display: block;
      width: 100%;
      height: 100%;
    }
    div {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 50%;
      width: 12px;
      height: 12px;
      background-color: rgba(100, 100, 100, 0.5);
    }
    &:hover div {
      background: linear-gradient(135deg, #339185 0%, #83bb60 100%);
      transform: scale(1.25);
    }
    &.active div {
      background: linear-gradient(135deg, #339185 0%, #83bb60 100%);
      transform: scale(1.25);
    }
  }
}

::v-deep .rasylva-logo-white {
  left: 50%;
  max-width: 400px;
  position: absolute;
  top: 36%;
  transform: translate(-50%, -50%);
  width: 50%;
}

::v-deep .landing-bg {
  bottom: -1px;
  height: calc(var(--vh, 1vh) * 100);
  left: 50%;
  position: relative;
  transform-origin: bottom;
  transform: translate(-50%) scale(0.8);
  vertical-align: bottom;
}

.landing-quote {
  bottom: 4vh;
  font-size: 4vw;
  margin: 0 auto;
  position: absolute;
  top: auto;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  @media only screen and (min-width: 700px) and (max-width: 960px) {
    bottom: 4vh;
    font-size: 2vw;
    width: 90%;
  }
  @media only screen and (min-width: 960px) {
    bottom: 4vh;
    font-size: 1.2rem;
    width: 50%;
  }
}

::v-deep .eagle {
  left: 72%;
  top: 17%;
  width: 9vh;
  @media only screen and (min-width: 960px) {
    left: 64%;
    top: 17%;
    width: 9vh;
  }
}

::v-deep .butterfly-1 {
  left: 14%;
  top: 51%;
  width: 5vh;
  @media only screen and (min-width: 700px) and (max-width: 960px) {
    left: 25%;
    top: 52%;
    width: 4vh;
  }
  @media only screen and (min-width: 960px) {
    left: 38%;
    top: 52%;
    width: 4vh;
  }
}

::v-deep .butterfly-2 {
  left: 22%;
  top: 47%;
  width: 3vh;
  @media only screen and (min-width: 700px) and (max-width: 960px) {
    left: 30%;
    top: 48%;
    width: 3vh;
  }
  @media only screen and (min-width: 960px) {
    left: 41%;
    top: 48%;
    width: 3vh;
  }
}

::v-deep .firefly {
  width: 4vh;
  transition: all 2.5s ease-in-out;
}

.sky-bg {
  background: rgba(255, 255, 255, 1);
  background: linear-gradient(
    180deg,
    rgba(30, 30, 30, 1) 0%,
    rgba(56, 147, 136, 1) 7%,
    rgba(102, 196, 186, 1) 15%,
    rgba(255, 255, 255, 1) 50%
  );
  height: calc((var(--vh, 1vh) * 100));
  min-height: 36rem;
  position: relative;
}

.sky-text {
  left: 50%;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  margin: auto;
}

.header-space {
  background: #83bb60;
  height: 56px;
  width: 100%;
  @media only screen and (min-width: 600px) {
    height: 63px;
  }
}

.bottom-space {
  padding-bottom: 8vh;
  @media only screen and (min-width: 960px) {
    padding-bottom: 16vh;
  }
}

::v-deep .liana-left,
::v-deep .liana-right {
  max-height: 100%;
  max-width: 12vh;
  position: absolute;
  top: 55px;
  @media only screen and (min-width: 700px) and (max-width: 960px) {
    max-width: 12vh;
  }
  @media only screen and (min-width: 960px) {
    max-width: 11vh;
  }
}

::v-deep .liana-left {
  left: 0;
  @media only screen and (min-width: 700px) and (max-width: 960px) {
    left: 32px;
  }
  @media only screen and (min-width: 960px) {
    left: 64px;
  }
}

::v-deep .liana-right {
  right: 0;
  @media only screen and (min-width: 700px) and (max-width: 960px) {
    right: 32px;
  }
  @media only screen and (min-width: 960px) {
    right: 64px;
  }
}

.advantage {
  left: 50%;
  position: relative;
  top: 69%;
  transform: translateX(-50%);
  width: 90%;
  background-color: white;
  padding: 24px 36px 24px 36px;
  border-radius: 72px;
  @media only screen and (min-width: 960px) {
    width: 85%;
    top: 45%;
    padding: 72px 36px 96px 36px;
    transform: translate(-50%, -50%);
  }
  &__item {
    margin: 0 8px;
    @media only screen and (min-width: 960px) {
      margin: 0 16px;
      padding: 0 28px;
    }
  }
}

.sevices-section {
  position: relative;
  background-color: $rasylva-teal;
  color: white;
  min-height: 90vh;
  background-size: cover !important;
  background-position: top center !important;
  background-repeat: no-repeat !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  @include desktop {
    min-height: auto;
  }
}

::v-deep .services-image {
  position: relative;
  object-fit: contain;
  width: 100%;
  padding: 0 24px;
  @include tablet {
    width: 68%;
  }
  @include desktop {
    width: 100%;
    margin: 0;
    max-height: 450px;
  }
}

.services-text {
  text-align: center;
  @include desktop {
    text-align: left;
    width: 90%;
    margin: auto;
  }
}

::v-deep .partner-image {
  height: 82px;
  margin: auto;
  @media only screen and (min-width: 960px) {
    height: 164px;
  }
}

::v-deep .landing-footer {
  bottom: 0;
  width: 100%;
  @media only screen and (min-width: 960px) {
    position: absolute;
  }
}
</style>
